import styled from 'styled-components';

import createCustomParser from '../createCustomParser';
import type { GridItemProps } from '../extensions';
import { gridItem } from '../extensions';
import styledFactory from '../styledFactory';

const systemProp = (name: string, property: string, scale: string) =>
  createCustomParser({
    [name]: {
      property,
      scale,
    },
  });

const between = systemProp('between', 'marginTop', 'ems');
const before = systemProp('before', 'paddingTop', 'ems');
const after = systemProp('after', 'paddingBottom', 'ems');

export interface Props extends GridItemProps {
  between?: any; // TODO ResponsiveValue<ThemeValue<'ems', DefaultTheme>>;
  before?: any; //ResponsiveValue<ThemeValue<'ems', DefaultTheme>>;
  after?: any; //ResponsiveValue<ThemeValue<'ems', DefaultTheme>>;
}

const SystemRhythm = styledFactory<Props, 'div'>(
  'div',
  'Rhythm',
  [gridItem],
  [before, after],
);

/**
 * A box for spacing children in a rhythm. In a rhythm the spacing between
 * elements depends on their respective font size, i.e em units. Relative
 * spacing can also be added before and after, this depends on the font size
 * set on the rhythm component itself.
 * The spacing props work just as https://styled-system.com/#space-theming
 *
 * Add `data-no-between="true" to a child element to override the rhythm
 * behaviour on that element.
 *
 * See also Stack for spacing children evenly between each other.
 */
const StyledRhythm = styled(SystemRhythm)`
  > * + :not([data-no-between='true']) {
    ${between}
  }
`;

export default StyledRhythm;
